// Returns an i18n key, not a label: callers must run it through t().
export const getVerdict = (grade) => {
  if (grade >= 8) return "analysis.verdict.excellent";
  if (grade >= 6) return "analysis.verdict.good";
  if (grade >= 4) return "analysis.verdict.average";
  return "analysis.verdict.toImprove";
};

export const getScoreColor = (score) => {
  if (score >= 7) return "success";
  if (score >= 5) return "warning";
  return "danger";
};

export const getValidatedCount = (items) => {
  if (!Array.isArray(items)) return { validated: 0, total: 0 };
  const non_na_items = items.filter((row) => row?.status !== "na");
  const validated = non_na_items.filter((row) => {
    if (row?.status === "ok") return true;
    if (row?.status) return false;
    if (typeof row?.score === "number" && typeof row?.max_score === "number") {
      return row.score >= row.max_score * 0.7;
    }
    return false;
  }).length;
  return { validated, total: non_na_items.length };
};

export const isGradeIgnored = (grade) => {
  return grade === -1 || grade === null || grade === undefined || grade === 0;
};
